module.exports = __webpack_public_path__ + "img/pup25.afb939b1.jpg";